import type { LoadStatus } from '../domain/linkedin-cookies.model';

/** Redux state for the account "LinkedIn" tab: the editable cookies + lifecycle. */
export interface LinkedinCookiesState {
  liAt: string;
  jsessionId: string;
  cookiesUpdatedAt: string | null;
  loadStatus: LoadStatus;
  saving: boolean;
}

export const initialState: LinkedinCookiesState = {
  liAt: '',
  jsessionId: '',
  cookiesUpdatedAt: null,
  loadStatus: 'idle',
  saving: false,
};
